import React from 'react';
import './PolicyPage.scss';
import HeaderPolicy from '../../components/Header/HeaderPolicy';
import LayoutPolicy from '../../components/Layout/LayoutPolicy';
import { history } from '../../_helpers/history';

function HelloOperatePolicyPage() {
    const titleText = "헬스케어 여기로 운영정책";
    
    const policyTextClick = (url) => {
        history.navigate(url);
    };

    return (
        <div className="policy" id="wrap">
            {/* header */}
            <HeaderPolicy title={titleText} />

            {/* contents, footer */}
            <LayoutPolicy>
                <div className="contents-new-agree__maintitle mt-0">
                    <span>
                        개요
                    </span>
                </div>

                <div className="contents-new-agree__text">
                    <span>
                        본 운영정책은 
                        <span onClick={() => policyTextClick("/policy/integrationService")} className="underline">
                            ‘살루스케어 통합서비스 약관’ 제 4조
                        </span>
                        에 따라 제정된 것으로 해당 약관들과 더불어 헬스케어 여기로(이하 헬로 혹은 서비스) 서비스 이용 계약을 구성합니다. <br />
                        헬스케어 여기로 운영정책에는 살루스케어(이하 회사)가 제공하는 헬로 서비스를 운영함에 있어, 서비스 내에서 발생할 수 있는 문제 상황에 대하여 일관성 있게 대처하기 위한 운영기준과 이용자(이하 회원) 여러분들이 서비스를 이용하며 지켜주셔야 할 세부적인 사항들이 규정되어 있습니다.
                    </span>
                </div>

                <div className="contents-new-agree__maintitle">
                    <span>
                        적용범위
                    </span>
                </div>

                <div className="contents-new-agree__text">
                    <span>
                        헬로 운영정책에는 헬로에서 제공하는 서비스 범위에 대하여 적용되며, 구체적인 서비스 범위는 본 운영정책 제 1조 운영정책의 목적 및 적용범위에서 확인할 수 있습니다. 그 외 별도의 언급이 없는 사항은 
                        <span onClick={()=>policyTextClick("/policy/accountTerm")} className="underline">
                            ‘살루스케어 계정약관’
                        </span> 및 
                        <span onClick={() => policyTextClick("/policy/integrationService")} className="underline">
                            ‘살루스케어 통합서비스 약관’
                        </span>
                        을 따릅니다.
                    </span>
                </div>

                <div className="contents-new-agree__maintitle">
                    <span>
                        제 1 장 총칙
                    </span>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 1 조 운영정책의 목적 및 적용범위
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>‘회사’가 본 운영정책에 따라 ‘회원’에게 제공하는 헬로 서비스의 주요 내용 및 운영정책의 적용 범위는 아래 각 호와 같으며, 세부적인 내용은 서비스 화면 내에 공지한 바에 따릅니다. 헬로 서비스의 내용은 각 호의 서비스를 포함하여 지속적으로 변화하며 제공되기 때문에 자세한 내용은 별도 공지를 참고하기 바랍니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>웰니스 기기를 활용한 건강정보, 지표의 측정 및 모니터링</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">I. </span>
                        <span>사용자가 선택한 패키지내에 있는 웰니스 기기를 활용하여 건강정보 및 지표를 측정하고 모니터링 할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>모니터링을 통한 건강지표, 상태에 대한 객관적인 통계 결과의 제시 및 개별 결과를 포함한 통합 결과 제시</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">I. </span>
                        <span>사용자가 선택한 상품내에 있는 웰니스 기기에서 제공하는 결과 및 정보를 가공하지 않고 객관적인 정보로 제공할 수 있습니다. 통합 결과의 경우 개별 웰니스 기기에서 제공되는 결과를 한번에 확인할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>‘회사’가 ‘회원’에게 제공할 수 있는 ‘헬로 패키지’는 다음과 같습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>헬로 라이트(Hello Light)</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">I. </span>
                        <span>검사항목: 스트레스 검사, 인지기능 검사, 수면분석 검사, 근골격 검사, 전립선 검사, PMS 검사</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">II. </span>
                        <span>결과 제공: 검사 종료일로부터 영업일기준3일 이내</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>헬로 바운스(Hello Bounce)</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">I. </span>
                        <span>검사항목: 스트레스 검사, 인지기능 검사, 수면분석 검사, 근골격 검사, 전립선 검사, PMS 검사, 심전도 측정, 보행분석 검사</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">II. </span>
                        <span>결과 제공: 검사 기기 회수일로부터 영업일기준7일 이내</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">3. </span>
                        <span>헬로 웨이브(Hello Wave)</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">I. </span>
                        <span>검사항목: 스트레스 검사, 인지기능 검사, 수면분석 검사, 근골격 검사, 전립선 검사, PMS 검사, 연속혈당검사</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">II. </span>
                        <span>결과 제공: 검사 종료일로부터 영업일기준 3일 이내</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">    
                        <span>헬로 프리미엄(Hello Premium)</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">I. </span>
                        <span>검사항목: 스트레스 검사, 인지기능 검사, 수면분석 검사, 근골격 검사, 전립선 검사, PMS 검사, 연속혈당검사, 심전도 측정, 보행분석 검사</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">II. </span>
                        <span>결과 제공: 검사 기기 회수일로부터 영업일기준7일 이내</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">5. </span>
                        <span>회원은 제공받은 패키지 및 검사 지침에 따라 정확히 데이터를 입력해야 하며, 임의로 절차를 변경하거나 생략할 수 없으며 검사 오류 발생 시 회사에 즉시 통보 해야 합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>기타 ‘회사’가 신규 개발하거나 다른 회사와의 제휴 등을 통해 ‘회원’에게 제공하는 일체의 서비스</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>‘회사’는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검 시간은 서비스내 공지한 바에 따릅니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑤</span>
                        <span>‘서비스’내 다른 회사가 제공하는 제휴 서비스의 경우 각 제휴사의 운영정책 및 약관을 따릅니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 2 조 운영원칙 및 기본방침
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>‘회사’가 본 운영정책, ‘살루스케어 계정약관’ 및 ‘살루스케어 통합이용약관’에 의하여 ‘회원’에게 제공하는 헬로 서비스는 ‘회원’ 개인의 질환 검사, 진단, 처방, 처치, 시술, 수술, 지도 등 의료행위나 의료 목적으로 제공하는 것이 아니며, “회원”의 건강의 유지･증진과 질병의 사전예방･악화 방지를 목적으로, 위해한 생활습관을 개선하고 올바른 건강관리를 유도하기 위한 비의료적, 보조적 건강관리 서비스를 제공합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>건강활동 관련 서비스의 경우, 질환보유자는 제공받는 서비스가 건강상태 및 보건위생상 위해가 생길 우려가 있는지에 대해 의사 등 의료기관의 상담 후 서비스를 이용하는 것을 권장합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>“회원” 개인의 신체나 건강에 이상이 발생하거나 기타 의학적인 판단이 필요할 경우, “회원”은 본 서비스에 의존할 수 없고 의사 등 전문가에게 상담, 검진, 진단을 받아야 함을 명확히 인지하고 본 서비스를 이용합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>“회사”가 “서비스”를 통해 제공하는 각종 정보는 객관적인 정보인 표준 데이터와 “회원”이 제공한 정보에 근거하므로, “회원”은 서비스에 반영되지 못한 개인적인 질병, 질환이나 모든 유전적 특성, 기타 구체적인 건강 상태를 고려하여 서비스를 이용하여야 합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑤</span>
                        <span>“회사”는 “회원”이 “서비스”를 통해 받거나 알게 된 정보는 전적으로 이용자의 판단에 따라 이용되는 것으로서, 정보의 정확성, 신뢰성, 효율성에 관한 책임을 부담하지 않습니다. 다만, 회사의 고의 또는 중대한 과실로 인하여 발생한 손해의 경우 제외합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑥</span>
                        <span>회사에서 제공되는 건강 관련 콘텐츠는 개략적이며 일반적인 내용으로써, 특정인의 의견에 지나지 않으며 어떠한 경우라도 의학적 진단, 진료 혹은 치료를 대신할 수 없습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑦</span>
                        <span>회사는 건강 관련 콘텐츠에서 언급된 어떠한 특정한 검사나 제품 혹은 치료법도 추천하지 않습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑧</span>
                        <span>회사에서 제공하는 건강 관련 정보는 전적으로 이용자의 판단에 따라 이용되는 것으로서, 회사는 건강 관련 콘텐츠의 제공과 관련하여 책임을 부담하지 않습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 3 조 용어의 정의
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>본 운영정책에서 사용하는 용어의 정의는 다음 각호와 같습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>‘헬로 서비스’란 회사가 제공하는 건강관리 플랫폼으로, Self 검진, 데이터 수집 및 분석, 건강 정보 제공, 제휴사 연계 검사 등의 기능을 포함하며, 보조적 건강 모니터링 서비스와 더불어 건강 유지 및 향상을 위한 재화 또는 용역(이하 ‘상품 등’이라 합니다)의 통신판매 서비스를 의미하며, 질환의 치료 목적의 서비스는 포함하지 않습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>‘회원’이란 회사의 ‘서비스’에 접속하여 ‘살루스케어 계정약관’, ‘살루스케어 통합이용약관’에 따라 회사와 이용 계약을 체결하고 회사가 제공하는 ‘헬로 서비스’를 이용하는 고객을 말합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">3. </span>
                        <span>‘사업장’이란 회사와 계약을 체결하여 소속 임직원들에게 서비스를 제공하는 법인 또는 단체를 의미합니다.</span>
                    </div>


                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">4. </span>
                        <span>‘헬로 패키지’란 회원이 신청하여 제공받는 건강관리 서비스 또는 관련 상품 등의 묶음을 의미합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">5. </span>
                        <span>‘임직원’이란 사업장에 소속되어 헬로 서비스를 이용하는 개인을 의미합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">6. </span>
                        <span>‘데이터’란 회원이 제공하거나 서비스 이용 과정에서 수집되는 건강 관련 정보, 활동 데이터 등을 포함하며, 회사가 서비스를 제공하기 위해 필요한 정보를 의미합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">7. </span>
                        <span>‘상품 등’이란 헬로 서비스에서 제공하는 건강 관리와 관련된 물품, 디지털 콘텐츠 또는 용역을 의미합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">8. </span>
                        <span>‘Self 검진’이란 회원이 헬로 패키지 또는 디지털 설문을 통해 스스로 건강 상태를 점검하는 기능을 의미합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">9. </span>
                        <span>‘제휴사’란 회사와 계약을 맺고 서비스를 함께 제공하는 협력 업체를 의미합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">10. </span>
                        <span>‘예약확정’이란 회원이 헬로 서비스에서 검사나 상품 등의 이용 일정을 확정한 상태를 의미합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">11. </span>
                        <span>‘구매확정’이란 회원이 상품/이용권 수령 후 헬로 서비스에 이용권 코드를 등록한 상태를 의미합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">12. </span>
                        <span>‘청약철회’이란 회원이 관련 법령에 따라 구매한 상품 등에 대한 계약을 취소하는 의사를 밝힌 상태를 의미합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">13. </span>
                        <span>‘철회가능’이란 판매/제조사 또는 개인사유로 인한 청약철회가 승인된 상태를 의미합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">14. </span>
                        <span>‘회수요청’이란 청약철회 및 검진완료에 따라 상품 등의 반품 또는 교환을 위해 회사에 회수를 요청한 상태를 의미합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">15. </span>
                        <span>‘결과지’란 Self 검진 또는 제휴사를 통해 진행된 검사를 기반으로 작성된 건강 상태 및 분석 결과를 나타내는 애플리케이션 화면을 의미합니다. 해당 결과지의 경우 회원의 건강정보를 이해하고 관리하기 위한 참고용으로만 사용되며, 의학적 진단이나 치료를 대체하지 않습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 4 조 운영정책 변경 및 공지
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>“회사”는 본 운영정책의 내용을 “회원”이 쉽게 알 수 있도록 서비스에 게시합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>“회사”가 운영정책을 개정할 경우에는 적용일자 및 개정사유 등을 명시하여 현재 적용되고 있는 운영정책과 함께 제1항의 방식에 따라 그 개정 운영정책의 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 운영정책 개정의 경우에는 개정 운영정책의 적용일자 30일 전부터 적용일자 전일까지 공지하고, 공지 외에 전자우편(E-mail) 등의 방법으로 개별 고지합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__maintitle">
                    <span>
                        제 2 장 서비스 운영
                    </span>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 5 조 서비스 파트너
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>서비스 파트너의 역할</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>회사는 회원에게 다양한 서비스를 제공하기 위해 제휴사(이하 "서비스 파트너")와 협력할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>서비스 파트너는 헬로 서비스와 연계된 추가 검사, 데이터 분석, 상품 제공 등의 서비스를 수행할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>서비스 파트너와의 계약 관계</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>회원이 서비스 파트너의 서비스를 이용하는 경우, 해당 서비스의 제공 조건은 서비스 파트너의 약관 및 정책에 따릅니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>회사는 서비스 파트너가 제공하는 서비스 품질에 대해 책임지지 않으며, 관련 분쟁 발생 시 회원은 서비스 파트너와 직접 해결해야 합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>데이터 제공 및 활용</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>회사는 회원의 동의를 받은 경우에 한해, 회원의 데이터를 서비스 파트너와 공유할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>데이터 공유는 서비스 제공 목적에 한정되며, 제3자에게 무단으로 제공되지 않습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">3. </span>
                        <span>서비스 파트너는 공유 받은 데이터를 헬로 서비스 제공 목적 외의 용도로 사용할 수 없습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>회원의 권리</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>회원은 서비스 파트너와의 협력 서비스 이용 시, 데이터 처리와 관련된 추가 동의를 요청 받을 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>회원은 언제든 데이터 공유에 대한 철회를 요청할 권리가 있으며, 철회 요청 시 회사는 서비스 파트너와의 데이터 공유를 즉시 중단합니다. 단, 서비스 이용을 위해 제휴사와 필수적으로 데이터 공유가 필요한 경우 서비스 사용이 어려울 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑤</span>
                        <span>서비스 파트너 관련 책임</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>서비스 파트너가 제공하는 서비스나 상품의 하자, 지연, 부실 등의 문제에 대해서는 해당 서비스 파트너가 책임을 집니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>회사는 서비스 파트너의 행위로 인해 발생한 손해에 대해 책임을 지지 않습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑥</span>
                        <span>서비스 파트너 정보 제공</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>회사는 회원이 서비스 파트너와의 협력 서비스를 이용하는 경우, 해당 서비스 파트너의 정보를 명확히 고지합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>고지 내용에는 서비스 파트너의 이름, 제공 서비스 범위, 연락처 및 약관 링크 등이 포함됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑦</span>
                        <span>서비스 변경 및 중단</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>서비스 파트너의 정책 변경, 계약 종료 등의 이유로 협력 서비스가 변경되거나 중단될 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>회사는 서비스 변경 또는 중단 시 회원에게 사전에 고지하며, 불가피한 경우 사후 고지할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑧</span>
                        <span>제휴사 연계 혜택 및 프로모션</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>회사는 제휴사와 협력하여 회원에게 추가 혜택이나 프로모션을 제공할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>이러한 혜택은 제휴사의 정책에 따라 제한되거나 변경될 수 있으며, 관련 사항은 회원에게 사전 안내됩니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 6 조 콘텐츠 및 정보 관리
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>“회원”의 “게시물”이 “정보통신망법” 및 “저작권법”등 관련법령에 위반되는 내용을 포함하는 경우, 해당 권리자는 관련법령이 정한 절차에 따라 해당 “게시물”의 게시중단 및 삭제 등을 요청할 수 있으며, “회사”는 관련법령에 따라 조치를 취하여야 합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>“회사”는 전항에 따른 권리자의 요청이 없는 경우라도 아래 각호와 같이 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법령에 위반되는 경우에는 관련법령 및 회사 정책에 따라 해당 “게시물”에 관하여 사전통지 없이 삭제, 블라인드 처리 등의 임시조치를 취할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>다른 회원 또는 제3자에게 심한 모욕을 주거나 명예를 손상시키는 내용인 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>선량한 풍속 및 기타 사회질서에 위반되는 내용을 유포하거나 링크 시키는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">3. </span>
                        <span>불법복제 또는 해킹을 조장하는 내용인 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">4. </span>
                        <span>영리를 목적으로 하는 광고일 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">5. </span>
                        <span>범죄와 결부된다고 객관적으로 인정되는 내용일 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">6. </span>
                        <span>다른 회원 또는 제3자의 지적재산권 등 기타 권리를 침해하는 내용인 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">7. </span>
                        <span>사적인 정치적 판단이나 종교적 견해의 내용으로 회사가 서비스 성격에 부합하지 않는다고 판단하는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">8. </span>
                        <span>타인의 건강을 위해 하는 검증되지 않은 허위정보로 판단될 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">9. </span>
                        <span>교육인 및 국내 교육기관 간의 비교 광고 성격으로 판단될 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">10. </span>
                        <span>의료인 및 국내 의료기관 간의 비교 광고 성격으로 판단될 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">11. </span>
                        <span>허가 받지 않은 의료행위 또는 의료행위를 위한 선전으로 게시물을 게재할 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">12. </span>
                        <span>회사에서 규정한 게시물 원칙에 어긋나거나, 게시판 성격에 부합하지 않는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">13. </span>
                        <span>기타 관계법령에 위배된다고 판단되는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>본 조에 따른 구체적인 절차는 “정보통신망법” 및 “저작권법”등 관련 법령이 규정한 범위 내에서 “회사”의 “살루스케어 통합서비스 약관 제 10조 게시물의 관리” 및 “헬로 운영정책”에 따릅니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 7 조 광고 및 마케팅 정책
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>“회사”는 “회원”이 “헬로 서비스” 이용 중 필요하다고 인정되는 다양한 정보를 서비스 화면, 전자우편, 카카오톡, 문자(SMS, MMS 등) 등의 방법으로 “회원”에게 제공할 수 있습니다. 다만, “회원”은 관련법령에 따른 거래관련 정보 및 고객문의 등에 대한 답변 등을 제외하고는 언제든지 전자우편 등의 소통 도구에 대해서 수신 거절을 할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>동조 제1항의 정보를 휴대전화 및 모사전송기기 등의 단말기에 의하여 전송하려고 하는 경우에는 “회원”의 사전 동의를 받아서 전송함을 원칙으로 합니다. 다만, “회원”의 거래관련 정보, 고객 문의로 인한 전자우편 발송 및 문자, 통화와 관련된 내용은 예외로 하며 수신을 거부하여 “회원”에게 발생되는 불이익에 대해서 “회사”는 책임지지 않습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>“회사”는 “서비스”의 운영과 관련하여 서비스 화면, 전자우편, 카카오톡, 문자(SMS, MMS 등) 등에 “회사” 또는 “제3자”의 광고를 게재할 수 있습니다. 광고가 게재된 전자우편을 수신한 “회원”은 수신거절을 “회사”에게 할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>“회원”과 서비스에 가입하지 않은 비회원은 회사가 제공하는 서비스와 관련하여 게시물 또는 기타 정보를 복사, 변경, 수정, 모방하거나, 이를 판매, 양도, 대여 또는 담보로 제공하는 행위, 타인에게 이용을 허락하는 행위를 하여서는 안됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑤</span>
                        <span>“회원”이 서비스상에 게재되어 있는 광고를 이용하거나 서비스를 통한 제3자의 판촉활동에 참여하는 방법으로 교신 또는 거래를 하는 것은 전적으로 “회원”과 제3자 간의 문제이며, “회사”는 광고의 내용을 보증하지 않습니다. 만약 “회원”과 제3자 간에 문제가 발생할 경우에도 “회원”과 제3자가 직접 해결해야 하며, 이와 관련하여 “회사”는 책임을 지지 않습니다. 다만, 회사의 고의 또는 중대한 과실로 인하여 발생한 손해의 경우 제외합니다.</span>
                    </div>
                </div>
            </LayoutPolicy>
        </div>
    )
}

export default HelloOperatePolicyPage;
